import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kasse-data-view',
  imports: [],
  templateUrl: './kasse.list-view.html',
  styleUrls: ['./kasse.list-view.css'],
})
export class KasseListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {}
}
